export default {
  modelSystemConfig: 'systemConfig',
  modelCustom: 'custom',
  getModelLabel(messageModel) {
    switch(messageModel) {
      case this.modelSystemConfig:
        return Core.Definition.getDefinition('Paramètres généraux');
        break
      case this.modelCustom:
        return Core.Definition.getDefinition('Personnalisé');
        break
      default:
        return ''
        break
    }
  },
  getModelOptions(keys) {
    if (keys === undefined) {
      keys = [this.modelSystemConfig, this.modelCustom]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.getModelLabel(key)
          }
      )
    }
    return options
  }
}
